/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useState } from "react";

import { ImageBlock } from "src/classes/block/block-types";
import { Plate } from "src/classes/plate/Plate";
import { ImagePicker } from "src/components/Block/BlockTypes/ImageBlock/ImagePicker";
import { Caption } from "src/components/Block/BlockTypes/ImageBlock/lib/Caption";
import { StyledImageBlockContent } from "src/components/Block/BlockTypes/ImageBlock/styles";
import { StyledImage } from "src/components/Block/BlockTypes/ImageBlock/styles";
import { FileStatusWrapper } from "src/components/Block/BlockTypes/utility/FileStatusWrapper";
import { StyledLoadingMessage } from "src/components/Block/styles";
import { ScribeSpinner } from "src/components/UI/Loading/Spinners/ScribeSpinner/ScribeSpinner";
interface Props {
  block: ImageBlock;
  editable: boolean;
  plate: Plate;
}

export function ImageBlockContent({ block, plate, editable }: Props) {
  const imageFit = block.observe((state) => state.imageFit);
  const hasCaption = block.observe((state) => state.hasCaption);

  const [imgLoading, setImgLoading] = useState(true);
  const [imgHasErrored, setImgHasErroed] = useState(false);

  return (
    <StyledImageBlockContent>
      <FileStatusWrapper
        block={block}
        fallbackComponent={editable && <ImagePicker block={block} editable={editable} plate={plate} />}
      >
        <StyledImage
          onLoad={() => setImgLoading(false)}
          onError={() => setImgHasErroed(true)}
          alt="block"
          src={!imgHasErrored ? block.getImageLinkForSize("dynamic") : block.fallbackImageLink}
          style={{
            objectFit: imageFit,
            display: imgLoading ? "none" : "block",
          }}
        />
      </FileStatusWrapper>
      {hasCaption && <Caption block={block} editable={editable} />}
      {imgLoading && (
        <StyledLoadingMessage>
          <ScribeSpinner />
        </StyledLoadingMessage>
      )}
    </StyledImageBlockContent>
  );
}
